import { fromJS } from 'immutable'
import moment from 'moment'

export const paymentState = fromJS({
  id: 0,
  orno: '',
  paydate: moment(),
  paydate_string: '', // this is the real payload
  sy: '',
  sem: '',
  student_id: 0,
  student_id_input: '',
  payee: '',
  is_check: false,
  is_locked: false,
  words: '',
  cashier_name: '',
  meta: {
    checknum: '',
    checkdate: '',
    checkbank: '',
    checkamount: '',
  },
  fees: [{
    id: 0,
    fee_id: 0,
    fee_code: '',
    fee_name: '',
    uacs: '',
    amount: '',
  }],
})

const initialState = fromJS({
  searchResults: [],
  item: {}, // holds the payment data
  today: 0,
  lastorno: 0,
  lastornoHasFetched: false,
  pending: false,
  searching: false,
})

export default function payment(state = initialState, action) {
  switch (action.type) {
    case 'PAY_REQ':
      return state.set('pending', true)

    case 'PAY_Q_REQ':
      return state.set('searching', true)

    case 'PAY_Q_SUCC':
      return state
        .set('searching', false)
        .set('searchResults', fromJS(action.payload || []))

    case 'PAY_LASTOR_SUCC':
      return state
        .set('pending', false)
        .set('lastornoHasFetched', true)
        .set('lastorno', action.payload)

    case 'PAY_GET2D_SUCC':
      return state
        .set('pending', false)
        .set('today', action.payload)

    case 'PAY_SAVE_SUCC':
    case 'PAY_GET_SUCC':
      return state
        .set('pending', false)
        .set('item', fromJS(action.payload.collection).set('paydate', moment(action.payload.paydate)))
        .set('today', action.payload.today)
        .set('lastorno', action.payload.lastorno)

    case 'NOTIF_FAIL':
      return state
        .set('pending', false)
        .set('searching', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Payments/reducer.js